module.exports = __webpack_public_path__ + "static/media/paypal.f408378d.png";